import React from 'react'
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next'
import { Box, Button, FormControl, Grid, Hidden, InputLabel, MenuItem, OutlinedInput, Select, Typography, useTheme } from '@mui/material'
import { alpha, Stack } from '@mui/system'
import { CountryCustom, NumbericInputCustom, SelectCustom, TextFieldCustom } from '../../components/FormElements';
import validators from '../../utils/validators';
import Container from '../../components/Container';
import DrawerComponent from '../../components/Drawer';
import { portal_config } from '../../portal.config';
import AlertComponent from '../../components/Alert';
import { replaceParamTranslation } from '../../utils/util';
import { ErrorWarningIcon, iconFontSize, ToggleActiveIcon, ToggleIcon } from '../../components/IconComponent';
import { GetIconColor } from '../../theme/main_style';

export default function AddMemberView(props) {

    const { relations, defaultValues, newContact, step, callingCountry, calling_countries, communitySelected, showCommunityType, message, resetForm } = props;
    const { t } = useTranslation();
    const {palette } =useTheme();
    const windowWidth = window.innerWidth;
    const invitation_method = [
        { label: "Email", value: "EMAIL" },
        { label: "Phone", value: "PHONE" },
    ]
    let accessLevel = [
        { label: t('access_level_restricted'), value: "RESTRICTED_ACCESS" },
        { label: t('access_level_full'), value: "FULL_ACCESS" }
    ]

    const renderRoot = () => {
        return (
            <>
                <Hidden mdUp>
                    <DrawerComponent isOpen={props.isOpen} onClose={props.onClose} title={t('add_member')}  headerPosition='relative' width='100%'>
                        {renderContent()}
                    </DrawerComponent>
                </Hidden>
                <Hidden mdDown>
                    <Container showProcessing={props.showProcessing} message={props.message}>
                        <DrawerComponent isOpen={props.isOpen} onClose={props.onClose} maxWidth='sm' enableCloseButton title={t('add_member')}  headerPosition='relative' width='100%'>
                            {renderContent()}
                        </DrawerComponent>
                    </Container>
                </Hidden>
            </>
        )
    }

    const renderContent = () => {
        return (
            <Box >
                <Form onSubmit={props.onSubmit}
                    render={({ handleSubmit, form }) => {
                        if(resetForm)
                        {
                            form.reset();
                            props.setResetForm(false);
                        }
                        return (
                            <>
                            <Box sx={{ width: '100%' }}>
                                <Stack direction="row" alignItems="center" justifyContent="space-between">
                                    <Typography variant="subtitle2" component={'span'}>{replaceParamTranslation(t('add_member_desc'), [communitySelected.group])}</Typography>
                                </Stack>
                            </Box>

                            <Box mt={1} paddingX={2} mb={2} width={'100%'} borderRadius={2} border={'1px solid'} borderColor={palette.border.main}>
                                <Typography variant="body2" marginTop={2} marginBottom={1} display='flex' justifyContent={'center'}>{t('invitation')}</Typography>
                                <Stack spacing={2} marginBottom={2}>
                                    <Field
                                        name="invitation_method"
                                        component={SelectCustom}
                                        isEdit={step===1 ? true : false}
                                        isValid={true}
                                        label={t('invitation_method')}
                                        keyName={'value'}
                                        keyLabel={'label'}
                                        selectData={invitation_method}
                                        valueSelect={defaultValues.invitation_method.value ? defaultValues.invitation_method.value : invitation_method[0].value}
                                        onSelectedChange={(e) => { props.onChange('invitation_method', e.target.value, 'value') }}
                                    />

                                {(defaultValues.invitation_method.value === 'EMAIL') && <Field
                                    name="email"
                                    component={TextFieldCustom}
                                    placeholder={t('email_recipient_placeholder')}
                                    isEdit={step===1 ? true : false}
                                    isValid={true}
                                    label={t('email')}
                                    validate={validators.composeValidators(validators.required, validators.validEmail)}
                                />}

                                {(defaultValues.invitation_method.value === 'PHONE') && 
                                <>
                                    <Grid item xs={12}>
                                    <Typography variant="body2">{t('phone_number')}{<Typography component={'span'} color={palette.error.main}>*</Typography>}</Typography>
                                </Grid>
                                <Grid item xs={12} container alignItems={'flex-start'}>
                                    <Grid item xs={4}>
                                        <Field
                                            name="country_code"
                                            component={CountryCustom}
                                            isEdit={true}
                                            selectData={calling_countries}
                                            defaultValueSelect={callingCountry && callingCountry.value ? callingCountry.value : null}
                                            valueSelect={callingCountry && callingCountry.value ? callingCountry.value : portal_config.default_country}
                                            onSelectedChange={(event) => props.onHandleChange('country_code', event.target.value)}
                                            placeholder={' '}                                                
                                            noMargin={true}
                                            onlyFlag={windowWidth < 768 ? true : false}
                                        />
                                    </Grid>
                                    <Grid item xs={8} paddingLeft={1}>
                                        <Field
                                            name="phone"
                                            component={NumbericInputCustom}
                                            formatType='numeric'
                                            placeholder={t('enter_your_phone_number')}
                                            isEdit={true}
                                            validate={ validators.composeValidators(validators.required, validators.mustBeNumberRequired)}
                                            startAdorment={<Typography>{callingCountry && callingCountry.phone_code ? '+' + callingCountry.phone_code : undefined}</Typography>}                                                
                                        />
                                    </Grid>
                                </Grid>
                                </>}

                                <Box my={2} py={1} px={3} backgroundColor={palette.info.main} borderRadius={2}>
                                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                        <ErrorWarningIcon color={palette.common.white} size={iconFontSize.xs} />
                                        <Typography color={palette.common.white} variant='subtitle2'>{t('add_member_email_desc')}</Typography>
                                    </Stack>
                                </Box>

                                {step===2 && newContact &&
                                    <>
                                        <Field
                                            name="first_name"
                                            component={TextFieldCustom}
                                            placeholder={t('first_name_input_placeholder')}
                                            isEdit={true}
                                            isValid={true}
                                            label={t('first_name')}
                                            validate={validators.composeValidators(validators.required)}
                                        />
                                        <Field
                                            name="last_name"
                                            component={TextFieldCustom}
                                            placeholder={t('last_name_input_placeholder')}
                                            isEdit={true}
                                            isValid={true}
                                            label={t('last_name')}
                                            validate={validators.composeValidators(validators.required)}
                                        />
                                    </>
                                }
                                </Stack>
                            </Box>

                            {step===2  && showCommunityType &&
                            <Box mt={1} paddingX={2} mb={2} width={'100%'} borderRadius={2} border={'1px solid'} borderColor={palette.border.main}>
                                <Typography variant="body2" marginTop={2} marginBottom={1} display='flex' justifyContent={'center'}>{t('community_type')}</Typography>
                                <Stack marginBottom={2}>
                                    <FormControl fullWidth sx={{marginTop: 0}}>
                                        <InputLabel id="community-type-label">{t('community_type_desc')}</InputLabel>
                                        <Select
                                            labelId="community-type-select"
                                            id="community-type"
                                            name="community-type"
                                            input={<OutlinedInput label={t('community_type_desc')}/>}
                                            onChange={(e) => props.onChange('relation', e.target.value, 'id')}
                                            value={defaultValues.relation && defaultValues.relation.id ? defaultValues.relation.id : null}
                                        >
                                            {relations.map((item, index) => {
                                                return (
                                                    <MenuItem key={index} sx={{
                                                        cursor: 'pointer',
                                                        ':hover': {
                                                            background: alpha(palette.primary.light, 0.11),
                                                        }
                                                    }} value={item.id}>
                                                        <Typography variant="subtitle2" component={'span'} fontStyle={!item.id &&'italic'}>{item.name}</Typography>
                                                    </MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Stack>
                            </Box>}

                            {step===2 && 
                            <>
                            <Box mt={1} paddingX={2} mb={1} width={'100%'} borderRadius={2} border={'1px solid'} borderColor={palette.border.main}>
                                <Typography variant="body2" marginTop={2} marginBottom={1} display='flex' justifyContent={'center'}>{t('access_level')}</Typography>
                                <Stack marginBottom={2}>
                                    <Field
                                        name="access_level"
                                        component={SelectCustom}
                                        selectData={accessLevel}
                                        keyName={'value'}
                                        isEdit={true}
                                        keyLabel={'label'}
                                        valueSelect={defaultValues.access_level && defaultValues.access_level.value ? defaultValues.access_level.value : accessLevel[0].value}
                                        onSelectedChange={(e) => props.onChange('access_level', e.target.value, 'value')}
                                    />
                                </Stack>
        
                                {defaultValues.access_level.value === 'RESTRICTED_ACCESS' && <>
                                    <Stack direction={'row'} alignContent={'center'} spacing={2}
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => props.onChange('restricted_access', {
                                            ...defaultValues.restricted_access,
                                            contact_management: !defaultValues.restricted_access.contact_management
                                        })
                                        }>
                                        <Stack>
                                            <Box>
                                                {defaultValues.restricted_access.contact_management ? <ToggleActiveIcon color={GetIconColor().primary}/> : <ToggleIcon color={GetIconColor().primary}/>}
                                            </Box>
                                        </Stack>
                                        <Stack flex={1}>
                                            <Typography variant='subtitle1'>{t('contact_management')}</Typography>
                                            <Typography variant='subtitle2' mb={1} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('contact_management_desc')}</Typography>
                                        </Stack>
                                    </Stack>
        
                                    <Stack direction={'row'} alignContent={'center'} spacing={2}
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() => props.onChange('restricted_access', {
                                            ...defaultValues.restricted_access,
                                            service_requests_management: !defaultValues.restricted_access.service_requests_management
                                        })
                                        }>
                                        <Stack>
                                            <Box>
                                                {defaultValues.restricted_access.service_requests_management ? <ToggleActiveIcon color={GetIconColor().primary}/> : <ToggleIcon color={GetIconColor().primary}/>}
                                            </Box>
                                        </Stack>
                                        <Stack flex={1}>
                                            <Typography  variant='subtitle1'>{t('service_requests_management')}</Typography>
                                            <Typography variant='subtitle2' mb={1} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('service_requests_management_desc')}</Typography>
                                        </Stack>
                                    </Stack>
        
                                    <Stack direction={'row'} alignContent={'center'} spacing={2}
                                        sx={{ cursor: 'pointer' }}
                                        onClick={() =>props.onChange('restricted_access',
                                            {
                                                ...defaultValues.restricted_access,
                                                orders_management: !defaultValues.restricted_access.orders_management
                                            })
                                        }>
                                        <Stack>
                                            <Box>
                                                {defaultValues.restricted_access.orders_management ? <ToggleActiveIcon color={GetIconColor().primary}/> : <ToggleIcon color={GetIconColor().primary}/>}
                                            </Box>
                                        </Stack>
                                        <Stack flex={1}>
                                            <Typography  variant='subtitle1'>{t('orders_management')}</Typography>
                                            <Typography variant='subtitle2' mb={2} sx={{ fontStyle: 'italic' , opacity:0.7}}>{t('orders_management_desc')}</Typography>
                                        </Stack>
                                    </Stack>


                                </>}
                            </Box>

                            <Stack direction="row" alignItems="center"  my={2} py={1} px={3} backgroundColor={palette.info.main} borderRadius={2}>
                                <Box width={24} display="flex" justifyContent="center" backgroundColor={palette.info.main} borderRadius={2}>
                                    <ErrorWarningIcon color={palette.common.white} size={iconFontSize.xs} />
                                </Box>
                                <Typography variant="subtitle2" sx={{marginLeft:2}} color={palette.common.white}>{t('add_member_wallet_sharing')}</Typography>
                            </Stack>

                            </>}

                            {step===1 &&
                            <Stack direction="row" alignItems="center" justifyContent="center" sx={{position: 'absolute', bottom: '50px', left: 0, width: '100%', px: 2, zIndex: 1300 }}>
                                <Button fullWidth variant="contained" id="addPeople/Continue" borderRadius={'50%'}
                                    onClick={handleSubmit}>
                                    {t('continue')}
                                </Button>
                            </Stack>
                            }

                            {step===2 &&
                            <Stack direction="row" alignItems="center" justifyContent="center" sx={{width: '100%', zIndex: 100 }}>
                                <Button fullWidth variant="contained" id="addPeople/Submit" borderRadius={'50%'}
                                    onClick={handleSubmit}>
                                    {t('send_invitation')}
                                </Button>
                            </Stack>
                            }
                            </>                            
                        )
                    }}
                />
            </Box>
            
        )
    }

    return (
        <>
            {renderRoot()}
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
        </>
        
    )
}